import { createSelector } from 'reselect';
import ReportByReferralComponent from '../../../../utils/ReportByReferralComponent/ReportByReferralComponent';

const location = (state) => state.routing?.location || state.routing?.locationBeforeTransitions || {};
const reportByReferral = (state) => state.serverStorage.store.reportByReferral || {};
const reportUtils = ReportByReferralComponent.utils;

export const getCheckedKeys = createSelector(
    location,
    reportByReferral,
    (location, reportByReferral) => {
        let metrics = (location.query && location.query.metrics) || reportByReferral.metrics || reportUtils.getDefStrMetric();
        let keysMetric = reportUtils.getKeysMetric(metrics);

        return keysMetric;
    }
);

export const getMetrics = createSelector(
    location,
    reportByReferral,
    (location, reportByReferral) => {
        return (location.query && location.query.metrics) || reportByReferral.metrics || reportUtils.getDefStrMetric();
    }
);

export const mainSelector = createSelector(
    reportByReferral,
    (reportByReferral) => {
        return reportUtils.getMultiLevelHeaderNames();
    }
);
